const tr = {
  translation: {
    1: "Hata: Yazdırma işlemi gerçekleştirilemedi",
    2: "Hata: Kaydetme işlemi gerçekleştirilemedi",
    3: "Çap 1'den büyük olmalıdır",
    4: "Çap değeri sayısal olmalıdır.",
    5: "Şekil mevcut değil",
    6: "Sph değeri sayısal olmalıdır",
    7: "Sph değeri yanlış",
    8: "Sph sınır dışı değeri (-30 / +30)",
    9: "Cyl değeri sayısal olmalıdır",
    10: "Cyl değeri yanlış",
    11: "Cyl değeri limit dışı (-10 / +10)",
    12: "Aks değeri sayısal olmalıdır",
    13: "Aks değeri pozitif olmalıdır",
    14: "Aks değeri 360'tan küçük olmalıdır",
    15: "Aks değeri bir tamsayı olmalıdır",
    16: "Değer sayısal olmalıdır",
    17: "Değer pozitif olmalıdır",
    18: "Değer şundan büyük olmalıdır",
    19: "Değer şundan küçük olmalıdır",
    20: "Değer -10 ile 10 arasında olmalıdır",
    21: "çap 99'dan küçük olmalıdır",
    22: "Yerel çerçeve tarayıcı belirtilmedi.",
    23: "PegasoDriver - Aygıt kullanılamıyor (Hizmet etkin değil veya bağlantı noktası zaten meşgul). Destek için müşteri hizmetleri ile iletişime geçin.",
    24: "ZAMAN AŞIMI: Şekil alınmadı",
    25: "Değer bir tamsayı olmalıdır",
    26: "Bu gözlükçü kodu zaten mevcuttur.",
    27: "Optisyen kaydedilirken hata oluştu.",
    28: "İşlem Başarısız Oldu",
    29: "Ürün veya şekil eksik.",
    30: "şekil eksik.",
    31: "Gerekli alanlar eksik.",
    32: "Hatalı alanlar.",
    33: "Firma bilgisi bulunamadı",
    34: "katalog  başlığı bulunamadı",
    35: "iş açmak imkansız",
    36: "iş eklemek imkansız",
    37: "işi klonlamak imkansız",
    38: "Oturumun süresi doldu",
    39: "BAŞLANGIÇ TARİHİ, BİR TARİH'ten küçük olmalıdır",
    40: "Değer yanlış",
    41: "İşin durumunu güncellemek imkansız",
    42: "tedarikçilere iş göndermek imkansız",
    43: "hata",
    44: "Tedarikçi bulunamadı",
    45: "Katalog mevcut değil",
    46: "Ürün kimliği eksik",
    47: "Katalog bulunamadı",
    48: "pegasoTools (tools=araçları) hata getirme",
    49: "Kataloğu içe aktarmak imkansız",
    50: "Yerel engelleyici belirtilmedi.",
    51: "Oturum açma başarısız oldu",
    52: "Çerçeveyi silmek imkansız",
    53: "Dosya dönüştürülmedi",
    54: "pegasoTools not active",
    55: "çap çok küçük.",
    56: "sipariş eksik",
    5000: "Asferik",
    5001: "Torik (kabartma yumru şeklinde)",
    5002: "Çift odaklı",
    5003: "Eğri üst",
    5004: "Çift Segment",
    5005: "Çizgili çok odaklı",
    5006: "Düz (pürüzsüz) üst",
    5007: "Merceksi",
    5008: "İlerici, aşamalı",
    5009: "Dörtlü odak",
    5010: "yuvarlak",
    5011: "Tek Görüş",
    5012: "üç odaklı",
    10000: "ilave",
    10001: "asferik",
    10002: "Torik (kabartma yumru şeklinde)",
    10003: "Otomatik",
    10004: "eksen (T)",
    10005: "sipariş",
    10006: "Pozisyon değeri",
    10007: "eğim konumu",
    10008: "Çift odaklı",
    10009: "Marka, tarz",
    10010: "İptal",
    10011: "kapalı",
    10012: "şehir",
    10013: "şirket",
    10014: "Profilinizi tamamlayın",
    10015: "ülke",
    10016: "eğri üst",
    10017: "silindir",
    10018: "tarih",
    10019: "Güncelleyen",
    10020: "Yükleyen",
    10021: "güncelleştirmek",
    10022: "tarafından indirildi",
    10023: "tablo",
    10024: "günler",
    10025: "çift kişilik",
    10026: "Cihazlar",
    10027: "Aygıt,cihaz",
    10028: "çap",
    10029: "devre dışı",
    10030: "Çift odaklı cam",
    10031: "Kenar verileri",
    10032: "düzenlemek",
    10033: "Profili düzenle",
    10034: "Çizgili çok odaklı",
    10035: "Kenar tipi",
    10036: "İş istatistiğini filtrele",
    10037: "Filtre durumu",
    10038: "Notlar",
    10039: "Düz (pürüzsüz) üst",
    10040: "Çerçeve Tipi",
    10041: "Tarihten itibaren",
    10042: "Oluk, çizgi",
    10043: "Yatay kutu",
    10044: "ev",
    10045: "Kimlik",
    10046: "Kod",
    10047: "Geçen haftaya göre artan istihdam",
    10048: "Şuna göre ekle",
    10049: "Gözbebekleri arası mesafe",
    10050: "İş ",
    10051: "İş listesi",
    10052: "Optisyen Listesi",
    10053: "iş basıldı",
    10054: "Günün işleri",
    10055: "Haftanın İşleri",
    10056: "Yılın işleri",
    10057: "iş doğru şekilde gönderildi",
    10058: "İş seçildi",
    10059: "İş İstatistiği",
    10060: "laboratuvar",
    10061: "Laboratuvar Notu",
    10062: "Laboratuvar Başvurusu",
    10063: "Laboratuvarlar",
    10064: "soyadı",
    10065: "sol lens",
    10066: "sipariş referansı harici laboratuvar",
    10067: "Merceksi",
    10068: "Bugün eklenen işlerin listesi",
    10069: "Geçen yılın işlerinin listesi",
    10070: "Lens Tipi",
    10071: "Oturum açma",
    10072: "Oturum kapatma",
    10073: "E-Posta Adresiniz",
    10074: "metal",
    10075: "model",
    10076: "Aylar",
    10077: "ad",
    10078: "Laboratuvara yeni işler geldi",
    10079: "Hayır",
    10080: "İş seçilmedi",
    10081: "Düzenlenecek iş yok",
    10082: "Bu filtrelerle sonuç bulunamadı",
    10083: "Şekil mevcut değil",
    10084: "Şekli dışa aktar",
    10085: "Dosyadan şekillendir",
    10086: "İzleyiciden şekillendir",
    10087: "Filtreler",
    10088: "Montaj yüksekliği",
    10089: "Telafi etmek, dengelemek",
    10090: "açık",
    10091: "açık İş",
    10092: "Optisyen",
    10093: "Optik müşteri",
    10094: "Optisyen notu",
    10095: "optik",
    10096: "Sipariş numarası",
    10097: "parola",
    10098: "Telefon",
    10099: "plastik",
    10100: "Lütfen görmek istediğiniz işlerin listesini filtreleyin",
    10101: "Lütfen görmek istediğiniz istatistik dönemini seçin",
    10102: "Parlatma, cila",
    10103: "yazdırmak",
    10104: "yeniden basmak",
    10105: "Profil",
    10106: "İlerici, aşamalı",
    10107: "İl",
    10108: "Dörtlü odak",
    10109: "son İşler",
    10110: "Sonuç türü",
    10111: "Sağ Lens",
    10112: "Çerçevesiz",
    10113: "yuvarlak",
    10114: "kurtarmak",
    10115: "Eğim Konumu Seç",
    10116: "Parlatma seç",
    10117: "İş yılını arayın.",
    10118: "İş ara",
    10119: "Gözlükçü Ara",
    10120: "Gözlükçü Notu Ara",
    10121: "Düzenlemek için bir İş seçin",
    10122: "Ayrıntıları görmek için bir İş seçin",
    10123: "Ayarlar",
    10124: "Kenar türünü seçin",
    10125: "Veri arama yöntemini seç",
    10126: "Tek Görüş",
    10127: "Lens Tipini Seçin",
    10128: "küre",
    10129: "Durum, devlet,hal",
    10130: "Istatistik",
    10131: "İstatistik dönemi",
    10132: "Sokak",
    10133: "(noun=isim),(number=sayı),(note=not),(North=kuzey)",
    10134: "etkin",
    10135: "Abonelik tarihi",
    10136: "Bugüne kadar",
    10137: "üç odaklı",
    10138: "tür",
    10139: "Profili Güncelle",
    10140: "Şunu güncelle:",
    10141: "Güncel İş",
    10142: "kullanıcı adı",
    10143: "Kullanıcı Ayarları",
    10144: "Dikey kutu",
    10145: "Haftalar",
    10146: "Devam Ediyor",
    10147: "evet",
    10148: "Sıkıştırılmış",
    10149: "Kimlik Doğrulama Sunucusu Hatası",
    10150: "geçersiz Kimlik Bilgisi",
    10151: "Geçersiz dosya biçimi",
    10152: "Yeni iş ekle",
    10153: "İşi görüntülemek için basın",
    10154: "İşi düzenlemek için basın",
    10155: "İşi kopyalamak için basın",
    10156: "Görüntülenecek kayıt yok",
    10157: "eklemek",
    10158: "silmek",
    10159: "düzenlemek",
    10160: "Geçersiz",
    10161: "kurtarmak",
    10162: "Bu satırı sildiğinizden emin misiniz?",
    10163: "Tracer'ı açın.",
    10164: "çerçeveyi Tracer'ın üzerine yerleştirin.",
    10165: "Okumayı yapmak için gözlüklü yeşil düğmeye basın.",
    10166: "Şeklin okunmasından sonra gözlüklü yeşil düğmeye tekrar basın.",
    10167: "Bilgisayar programındaki -Al- tuşuna basın.",
    10168: "Şekli okuduktan sonra (BİP sesini duyduğunuzda) Bilgisayar programındaki -Al- tuşuna basınız.",
    10169: "Okumak için yeşil düğmeye basın.",
    10170: "Tracer şekli okurken bilgisayar programı üzerinde bulunan -al- butonuna basınız.",
    10171: "Çerçevenin okumasını yapın.",
    10172: "Şekli bilgisayara göndermek için izleyiciden -Kaydet- düğmesine basın.",
    10173: "Okumayı bitirdikten sonra Tracer üzerindeki -değiştirme- düğmesine basın.",
    10174: "okumak için -B (İKİSİ BİRDEN)- tuşuna basın.",
    10175: "İzleyici Ekranında sağda -RSA- ifadesini görebileceğinizi kontrol edin (Farklı olması durumunda, -RSA- olarak değişene kadar CTL ve +/-'ye basın ve izleyiciyi yeniden başlatın).",
    10176: "Çerçeveyi okumaya başlamak için izleyiciye iki kez -Başlat- basın.",
    10177: "Yukarıdaki led yandığında izlemenin sonundaki -VERİ- düğmesine basın.",
    10178: "okumak için Başlat düğmesine basın.",
    10179: "GT500 ise: Yukarıdaki led yandığında izlemenin sonundaki -VERİ- düğmesine basın.",
    10180: "Tek bağlan",
    10181: "Tek Al",
    10182: "ayırmak",
    10183: "Döngüyü al",
    10184: "almak",
    10185: "Cihaza bağlanıyor...",
    10186: "cihazdan veri bekleniyor...",
    10187: "Cihaz bağlantısı kesiliyor...",
    10188: "Satırları seç:",
    10189: "Sayfa başına satır:",
    10190: "önceki Sayfa",
    10191: "sonraki Sayfa",
    10192: "Fiyat",
    10193: "KDV numarası",
    10194: "sayı",
    10195: "adres",
    10196: "Katalog",
    10197: "Katalog Yönetimi",
    10198: "values",
    10199: "karşıya yükleme",
    10200: "Katalog güncellendi",
    10201: "Düzeyler, seviyeler",
    10202: "Ayrıntı",
    10203: "değerler",
    10204: "Harici kodlar",
    10205: "onaylamak",
    10206: "Kataloğu silmek istediğinizden emin misiniz?",
    10207: "Yüklenen Katalog",
    10208: "dikkat",
    10209: "Bir Excel dosyasını buraya sürükleyip bırakın veya tıklayın",
    10210: "Ürün Ara",
    10211: "ön",
    10212: "yüzde",
    10213: "Geri",
    10214: "Değiştirmek",
    10215: "ürün",
    10216: "Bu ürünü ekliyorsunuz",
    10217: "Gruplandırma ölçütü olarak Başlık'ı buraya sürükleyin",
    10218: "İş Listesini Yenile",
    10219: "Gerekli Alanlar",
    10220: "Gerekli alanlar güncellendi",
    10221: "Verileri şekillendirme",
    10222: "iş Verileri",
    10223: "Ürünü kaldır",
    10224: "Ürünleri şu şekilde sipariş edin:",
    10225: "uzaktan-Destek",
    10226: "Sipariş Gerekli Alanlar",
    10227: "Aramak için tek bir sipariş veya sipariş dönemi seçin",
    10228: "Yıl aramak için iki sipariş dönemi seçin",
    10229: "TAMAM",
    10230: "Temiz",
    10231: "Boş",
    10232: "Bugün",
    10233: "Filtreleri sıfırla",
    10234: "Tedarikçiye iş gönder",
    10235: "Siparişi iletmek istediğiniz tedarikçiyi seçin",
    10236: "Gönder",
    10237: "yıl",
    10238: "Kapatmak için basın",
    10239: "İş tedarikçiye gönderildi",
    10240: "İşi Sil",
    10241: "dikkat",
    10242: "Geçerli işi silmek istediğinizden emin misiniz?",
    10243: "İptal",
    10244: "onaylamak",
    10245: "Oluşturan",
    10246: "Tabu Sistemi",
    10247: "kenarda minimum kalınlık 2 mm",
    10248: "Sipariş doğru şekilde kapatıldı",
    10249: "Siparişi Kapat",
    10250: "El ile",
    10251: "",
    10252: "Marka Seçiniz",
    10253: "Cihaz adı",
    10254: "Seri",
    10255: "İnternet protokolü",
    10256: "Haberleşme Bağlantı Noktası",
    10257: "Yalnızca bağlantı noktası numarasını girin",
    10258: "Hız Bağlantı Noktası",
    10259: "eşlik biti",
    10260: "veri biti",
    10261: "durdurma biti",
    10262: "İnternet protokolü adresi",
    10263: "internet protokolü bağlantı noktası",
    10264: "hiç kimse",
    10265: "bile, eşit",
    10266: "garip",
    10267: "Gelişmiş Ayarlar Protokolü",
    10268: "Seçenek İndirme",
    10269: "Seçenek yükleme",
    10270: "Kaydet Düzenle",
    10271: "Gelişmiş Ayarlar Seri",
    10272: "IP Protokolü",
    10273: "Barkodu olmayan iş",
    10274: "Olumsuz onay, Hatalı alım bildirimi",
    10275: "Ofset Metal",
    10276: "ofset plastik",
    10277: "tek taraflı",
    10278: "İzleyici Kimliği",
    10279: "barkodsuz",
    10280: "Gereksinimleri",
    10281: "İzleme Biçimleyici İkili Çıktısı",
    10282: "İzleme Noktaları Formatlayıcı",
    10283: "Sıkıştırılmış ikili izleme formatı",
    10284: "Sıkıştırılmış ikili izleme noktaları formatı",
    10285: "seçilmiş",
    10286: "Zaman aşımı",
    10287: "Karşılıklı",
    10288: "Bellek Boyutu",
    10289: "Yazma tamponunun boyutu",
    10290: "Okuma işlemi sırasında beklenebilecek maksimum süre",
    10291: "Yazma zaman aşımı süresi",
    10292: "Gönderme isteği",
    10293: "Veri terminali hazır",
    10294: "Boş (null) karakteri yoksay",
    10295: "Diğer konuma göre sapma/fark",
    10296: "Kaydedilen ayarların etkili olması için çıkış yapın",
    10297: "İş doğru şekilde düzenlendi",
    10298: "İşi tedarikçiye izleyici olarak gönder (SERİ PORT)",
    10299: "Bağlantı en az 1.5.1 sürümü olmalı",
    10300: "Lens malzemesi",
    10301: "Kaplama merceği",
    10302: "kaygan değil",
    10303: "Kenar kalınlığı",
    10304: "Merkez kalınlığı",
    10305: "oluk genişliği",
    10306: "oluk derinliği",
    10307: "Yüksek güvenlik",
    10308: "Düşük güvenlik",
    10309: "Lens malzemesini seçin",
    10310: "lens kayganlığını seçin",
    10311: "düşük kaygan",
    10312: "yüksek kaygan",
    10313: "İzleyici Ayarları",
    10314: "Kalibrasyon ayarları güncellendi",
    10315: "Kalibrasyon ayarları",
    10316: "yükseklik değeri (Y)",
    10317: "genişlik değeri (X)",
    10318: "Ekrandaki çizimin doğru bir şekilde kalibre edilmesi için, X ve Y değerlerini, karenin her iki tarafının uzunluğu 80 mm olacak şekilde değiştirmek gerekir",
    10319: "Matkap yönetimi",
    10320: "Matkap ekle",
    10321: "Matkapları silme",
    10322: "Matkapları kaydedin",
    10323: "İş Numarasını Seçin",
    10324: "Manuel iş numarası",
    10325: "En fazla",
    10326: "Çerçeve yönetimi",
    10327: "Tedarikçi Listesi",
    10328: "Tedarikçi arayın",
    10329: "tedarikçi zaten var",
    10330: "tedarikçi,satıcı",
    10331: "Çerçeve verileri",
    10332: "marka,damga",
    10333: "Çerçeve Kimliği",
    10334: "Model adı",
    10335: "Renk",
    10336: "Kalibre, çap",
    10337: "Marka Listesi",
    10338: "Marka bul",
    10339: "marka zaten var",
    10340: "Çerçeveyi Düzenle",
    10341: "Çerçeveyi sil",
    10342: "çerçeveyi açmak imkansız",
    10343: "Kaydetme Başarısız: Bu kimliğe sahip çerçeve zaten var",
    10344: "Çerçeve kaydedilmedi",
    10345: "Veritabanından şekil alma",
    10346: "Okumayı başlatmak için düğmeye basın.",
    10347: "Şekli değiştir",
    10348: "Şekli kaydet",
    10349: "yukarı",
    10350: "aşağı",
    10351: "Sağ",
    10352: "Sol",
    10353: "en fazla 1 ay",
    10354: "Tür: Tatbikatı düzenle",
    10355: "Matkap düzenleme türünü seçin",
    10356: "Merkezinde",
    10357: "Kenarında",
    10358: "AutoCAD Dönüştürücü",
    10359: "OMA dosyası DXF'de doğru şekilde dönüştürüldü. İndirmek için tıklayınız",
    10360: "Lütfen tekrar denemek yerine dosyanın doğru olup olmadığını kontrol edin",
    10361: "hata: Tekrar deneyin, sorun devam ederse Pegaso ile iletişime geçin",
    10362: "OMA - DXF dönüştürücü",
    10363: "OMA dosyasını sürükleyip bırakın veya buraya tıklayın",
    10364: "Dosyayı dönüştürmek için tıklayın",
    10365: "Dosyayı Dönüştür",
    10366: "Dosyayı indir",
    10367: "DXF'den OMA'ye dönüştürücü",
    10368: "Nasıl bir sonuç istiyorsun?",
    10369: "her ikisi",
    10370: "Dosya nasıl oluşturulur?",
    10371: "DXF dosyasını sürükleyip bırakın veya buraya tıklayın",
    10372: "DXF dosyası OMA'da doğru şekilde dönüştürüldü. İndirmek için tıklayınız",
    10373: "AutoCad projesi, şeklin temsili için yalnızca EĞRİ ve SÜREKLİ ÇİZGİ yi ve matkapların temsili için DAİRE yi içermelidir",
    10374: "AutoCad projesindeki diğer tüm öğeler göz ardı edilecektir",
    10375: "Dönüştürülecek OMA dosyası, OMA/VCA protokolünün tüm standartlarına uygun olmalıdır.",
    10376: "çerçeve",
    10377: "çerçeve markası",
    10378: "çerçeve tedarikçisi",
    10379: "Müşteriler tarafından görülebilen alanlar",
    10380: 1,
    10381: 0,
    10382: "Yeni çerçeve ekle",
    10383: "Tedarikçi Kimliği",
    10384: "Marka Kimliği",
    10385: "yan",
    10386: "Bir şekil dosyasını sürükleyip bırakın veya buraya tıklayın",
    10387: "Gözlükçü müşterisini ara",
    10388: "Dönüştürücü Çalıştırma Kılavuzu:",
    10389: "Kutudan yüksek",
    10390: "Kenar arkası pim eğim genişliği",
    10391: "kenar ön pimi eğim genişliği",
    10392: "seçmek",
    10393: "Kimyasallara dayanıklı plastik",
    10394: "Polikarbonat",
    10395: "cam",
    10396: "desen",
    10397: "Yüksek kırma indeksli (ince) cam",
    10398: "Trivex cam malzemesi (Yüksek performanslı plastik malzeme)",
    10399: " üç kanatlı kuş ",
    10400: "çerçeve eğrisi",
    10401: "Bir merceğin ön eğrisi",
    10402: "çerçeve sarma açısı",
    10403: "Cam kırılma indisi",
    10404: "Lens indeksini seç",
    10405: "Web arayüzü üzerinden iş oluşturmak için izleyici tipini ve izleyicinin seri iletişim portunu seçin",
    10406: "Lens verileri",
    10407: "İptal",
    10408: "Gönder",
    10409: "Kenarından yüksek",
    10410: "Kataloğu Excel'in dışına aktar",
    10411: "Kaplama",
    10412: "İş arama türünü seçin",
    10413: "Tek iş ara",
    10414: "Dönem içinde iş arayın",
    10415: "Harici sistem için geri yükleme işi",
    10416: "İş doğru şekilde geri yüklendi",
    10417: "İş geri yüklenmedi",
    10418: "Ön-arka eğim açısı",
    10419: "Kornea tepe noktası mesafesi",
    10420: "Sipariş Ayarları",
    10421: "Kenar yüksekliği giriş yöntemi",
    10422: "Kutudan/Kutu içerisinden",
    10423: "Kenarından",
    10424: "Silin",
    10425: "şekli silmek imkansız",
    10426: "Bu şekli silmek istediğinizden emin misiniz?",
    10427: "durum",
    10428: "Y konum değeri çok büyük (delik)",
    10429: "X konum değeri çok büyük (delik)",
    10430: "Şekil ön hesaplama/Şekil ön kalibrasyonu",
    10431: "Şekil ön hesaplama yöntemi",
    10432: "ön hesaplama şekillerini yenile",
    10433: "Yeni şekil ekle",
    10434: "Şekil Kimliği",
    10435: "Açıklama",
    10436: "Oranları koruyun",
    10437: "Dil",
    10438: "Ayarlar doğru kaydedildi, programdan çıkın",
    10439: "işi engelleyiciye gönder (SERİ BAĞLANTI NOKTASI)",
    10440: "Engelleyici bağlantısı kesiliyor",
    10441: "Engelleyiciye bağlanma",
    10442: "Veri göndermek için bekleniyor",
    10443: "Veriler doğru şekilde gönderildi",
    10445: "Şekil gönderilmedi",
    10446: "İlk sayfa",
    10447: "Son sayfa",
    10448: "İzleyiciyi kaldırın ve kaydedin",
    10449: "Dikkat: Daha önce gönderilmiş bir siparişi göndermeye çalışıyorsunuz. Devam etmek istiyor musunuz?",
    10450: "En az çap",
    10451: "Seçilen çap",
    10452: "Çapı hesapla",
    10453: "Hesaplama için göz bebekleri arası mesafe, montaj yüksekliği, köprü ile yatay ve dikey çerçeve ölçüleri gereklidir",
    10454: "Model bul",
    10455: "prizma",
    10456: "prizma tabanı",
    10457: "Buraya bir klasör sürükleyin",
    10458: "Yüklenen klasörün içindeki dosyalar",
    10459: "Şekilleri almak için tıklatın",
    10460: "Şekilleri içe aktarma",
    10461: "İçe aktarılan dosyalar",
    10462: "İçe aktarılmayan dosyalar",
    10463: "Wecolab'dan XML dosyalarını içe aktar",
    10464: "En az bir filtre seçin",
    10465: "Çerçeve kaydedildi",
    10466: "Delik açma/kanal açma",
    10467: "R/L val",
    10468: "Her iki tarafı dönüştü",
    10470: "UYARI: Oturumunuz süresi doldu, lütfen tekrar giriş yapın",
    10471: "İşleri dışa aktar",
    10472: "İndirme devam ediyor",
    10473: "Tüm işleri indirmek için düğmeye tıklayın",
    10474: "Eksik şekil, siparişi yeniden girin",
    10475: "Eksik şekil, şekli veritabanına yeniden yükleyin",
    10476: "Eksik şekil, okumayı tekrarlayın",
    10477: "Destek",
    10478: "Yinelenen siparişleri yeniden yazdır",
    10479: "Yazdırılan işler",
    10480: "Başlangıç sipariş numarası",
    10481: "Bitiş sipariş numarası",
    10482: "'Başlangıç' değeri 'bitiş' değerinden küçük olmalıdır",
    10483: "'Bitiş' değeri 'başlangıç' değerinden büyük olmalıdır",
  }
}
export default tr
